import { TagTypes } from "../../../Api/Types/tagTypes";
import { Company } from "../Types/companyTypes";
import { ImageDto } from '../../Images/Types/imageTypes';
import { companiesApi } from './companiesApi';

const extendedCompaniesApi = companiesApi.injectEndpoints({
  endpoints: (builder) => ({
    update: builder.mutation<Company, { id: number; data: Partial<Company> }>({
      query: ({ id, data }) => ({
        url: `/companies/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: TagTypes.Company, id },
        { type: TagTypes.BankAccount, id: `COMPANY_${id}` },
      ],
    }),
    getCompanyImages: builder.query<ImageDto[], number>({
      query: (companyId) => `/images/company/${companyId}`,
      providesTags: (result, error, companyId) => [
        { type: TagTypes.Images, id: `COMPANY_${companyId}` },
        ...(result?.map((img) => ({ type: TagTypes.Images as const, id: img.id })) || []),
      ],
    }),
    uploadCompanyImages: builder.mutation<
      { imageIds: string[]; count: number },
      { companyId: number; files: File[] }
    >({
      query: ({ companyId, files }) => {
        const formData = new FormData();
        files.forEach((file) => formData.append('Files', file));
        formData.append('Category', 'Company');
        formData.append('EntityId', companyId.toString());

        return {
          url: '/images/upload-multiple',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, { companyId }) => [
        { type: TagTypes.Images, id: `COMPANY_${companyId}` },
        { type: TagTypes.Company, id: companyId },
      ],
    }),
    deleteCompanyImage: builder.mutation<void, { imageId: string; companyId: number }>({
      query: ({ imageId }) => ({
        url: `/images/${imageId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { companyId }) => [
        { type: TagTypes.Images, id: `COMPANY_${companyId}` },
        { type: TagTypes.Company, id: companyId },
      ],
    }),
  }),
  overrideExisting: true,
});
export const {
  useUpdateMutation: useUpdateBankAccountExtMutation,
  useGetCompanyImagesQuery,
  useUploadCompanyImagesMutation,
  useDeleteCompanyImageMutation,
} = extendedCompaniesApi;
